import styled from 'styled-components';
import { grey } from '@mui/material/colors';
import { ThemeEnum } from '../../handlers/ThemeHandler';

export const AddTileButton = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  cursor: pointer;
`;

export const GridItemWrapper = styled.div<{
  height?: string;
  padding?: string;
  width?: string;
}>`
  & .tile-button {
    background: rgba(0, 0, 0, 0.2);
    color: ${grey[100]};
  }

  height: ${({ height }) => (height ? height : 'calc(50% - 2.5px)')};
  width: ${({ width }) => width};
  padding: ${({ padding }) => (padding ? padding : 'initial')};
`;

export const SideTiles = styled.div`
  display: flex;
  flex-flow: column;
  width: 20%;
  margin-right: 5px;
`;

export const MainTiles = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  align-items: center;
  justify-content: space-between;
`;

export const Tile = styled.div<{ isDraggedOver: boolean; isLogoTile: boolean }>`
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
  overflow-y: hidden;

  border: ${({ isDraggedOver }) => (isDraggedOver ? '1px dotted #9ca20c' : '')};

  .grid-edit-icon {
    position: absolute;
    color: ${({ theme }) =>
      theme.theme === ThemeEnum.light ? '#000000' : '#fff'};
    font-size: 1px;
    top: 0;
    right: 0;
    cursor: pointer;
    opacity: 0;
    transition: all 0.5s;
  }

  &.static-tile {
    div {
      background-size: contain;
    }
    background: ${({ theme }) =>
      theme.theme === ThemeEnum.light ? 'white' : '#0e0f13'};
    ${({ isLogoTile }) =>
      isLogoTile ? 'box-sizing: border-box; padding: 10px' : ''};
  }

  &[draggable='true'] {
    cursor: grab;
  }

  &:hover:not(.static-tile) {
    opacity: 0.6;
    svg {
      opacity: 1;
      z-index: 1000;
      font-size: 35px;
    }
  }
`;
